import { Effect, Schema as S } from "effect";
import * as Mount from "foldkit/mount";

import { Message } from "../app/main";
import type { ClerkAdapter } from "./adapter";

const define = (
	name: string,
	mount: (element: HTMLDivElement) => void,
	unmount: (element: HTMLDivElement) => void,
) =>
	Mount.define(name, {
		messages: [Message.MountedClerkUi],
		execute: ({ element }) =>
			Effect.gen(function* () {
				yield* Effect.acquireRelease(
					Effect.sync(() => {
						mount(element as HTMLDivElement);
						return element as HTMLDivElement;
					}),
					(host) => Effect.sync(() => unmount(host)),
				);
				return Message.MountedClerkUi();
			}),
	});

/** Clerk's prebuilt UI on Foldkit element lifetimes (KTD6): mount in acquire, unmount in release. */
export const makeClerkMounts = (adapter: ClerkAdapter) => ({
	SignIn: define("ClerkSignIn", adapter.mountSignIn, adapter.unmountSignIn),
	OrganizationSwitcher: define(
		"ClerkOrganizationSwitcher",
		adapter.mountOrganizationSwitcher,
		adapter.unmountOrganizationSwitcher,
	),
	UserButton: Mount.define("ClerkUserButton", {
		args: {
			isAdmin: S.Boolean,
			integrationsEnabled: S.Boolean,
			billingPreviewEnabled: S.Boolean,
			showName: S.Boolean,
		},
		messages: [Message.MountedClerkUi],
		execute: ({
			element,
			isAdmin,
			integrationsEnabled,
			billingPreviewEnabled,
			showName,
		}) =>
			Effect.gen(function* () {
				yield* Effect.acquireRelease(
					Effect.sync(() => {
						const host = element as HTMLDivElement;
						adapter.mountUserButton(host, {
							isAdmin,
							integrationsEnabled,
							billingPreviewEnabled,
							showName,
						});
						return host;
					}),
					(host) => Effect.sync(() => adapter.unmountUserButton(host)),
				);
				return Message.MountedClerkUi();
			}),
	}),
});
export type ClerkMounts = ReturnType<typeof makeClerkMounts>;
